export const HAS_CRIMINAL = {
  NO: 0,
  YES: 1,
  API_FAIL: 2
}

export const ERROR_CRIMINAL_MESSAGES = {
  VEHICLE_TYPE_MISMATCH: { title: 'Tra cứu không thành công', content: 'Biển số không hợp lệ' },
  INVALID_PLATE_NUMBER: { title: 'Tra cứu không thành công', content: 'Biển số không hợp lệ' },
  INVALID_VEHICLE_CERTIFICATE: { title: 'Tra cứu không thành công', content: 'Số seri không hợp lệ' },
  VEHICLE_NOT_FOUND: { title: 'Tra cứu không thành công', content: 'Không tìm thấy thông tin phương tiện' },
  REQUEST_LIMIT_EXCEEDED: {
    title: 'Đã đạt giới hạn tra cứu',
    content: 'Bạn đã thực hiện quá số lần tra cứu trong ngày.\nVui lòng quay lại vào hôm sau nhé!'
  }
}
